var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2247.44,-2192.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "matrix(1.11561,0,0,1.11561,-586.889,305.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2540.62,
    y: 1691.81,
    width: 313.731,
    height: 313.731,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2540.62,
    y: 1691.81,
    width: 313.731,
    height: 313.731
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26678,0,0,1.0723,1454.56,-169.737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 857.344,
    y: 1736.04,
    width: 248.1,
    height: 293.253,
    style: {
      fill: "rgb(248,248,248)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.44,1736.04L857.344,1736.04L857.344,2029.29L1105.44,2029.29L1105.44,1736.04ZM1095.66,1747.59L1095.66,2017.73C1055.93,2017.73 906.854,2017.73 867.125,2017.73C867.125,1970.78 867.125,1794.54 867.125,1747.59C867.125,1747.59 1095.66,1747.59 1095.66,1747.59L1095.66,1747.59Z",
    style: {
      fill: "rgb(57,57,57)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "page-down-arrow",
    transform: "matrix(4.43871,0,0,4.43871,-1564.99,-2724.23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.336587,0,-8.29752e-33,0.336587,637.931,697.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.005,1035.88L957.844,1068.52L990.483,1035.88",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "15.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,-3.76567e-32,1.52754,1.33088e-29,-539.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.329,1045.45L960.329,1033.93",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "4.16px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "page-down-arrow1",
    transform: "matrix(-3.92755,4.80986e-16,-4.80986e-16,-3.92755,6469.09,5896.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.336587,0,-8.29752e-33,0.336587,637.931,697.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.005,1035.88L957.844,1068.52L990.483,1035.88",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "15.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,-3.76567e-32,1.52754,1.33088e-29,-539.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.329,1045.45L960.329,1033.93",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "4.16px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "page-down-arrow2",
    transform: "matrix(1.68402e-16,2.75021,-2.75021,1.68402e-16,5461.38,-791.615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.336587,0,0,0.336587,637.931,697.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.005,1029.58L925.005,1035.88L953.549,1059.18L957.844,1060.02L962.124,1059.18L990.483,1035.88L990.483,1029.58",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "15.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,2.23694e-18,3.41701e-18,1.47173,-1.54714e-14,-482.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.329,1045.45L960.329,1033.93",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "4.16px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "page-down-arrow3",
    transform: "matrix(-1.63567e-16,2.67125,2.67125,1.63567e-16,17.8488,-715.796)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.336587,0,0,0.336587,637.931,697.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.005,1029.58L925.005,1035.88L953.549,1059.18L957.844,1060.02L962.124,1059.18L990.483,1035.88L990.483,1029.58",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "15.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33216e-16,1,-2.38028,3.79021e-17,3435.04,81.5304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960.329,1045.45L960.329,1033.93",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "2.87px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19407,0,0,1.19407,-510.049,-358.077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2609.19,1839.29L2628.17,1858.28",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "6.51px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.31155e-17,1.19407,-1.19407,7.31155e-17,4824.41,-1277.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2609.19,1839.29L2628.17,1858.28",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "6.51px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896374,0,0,0.896374,273.161,201.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2640.19,1851.65L2659.68,1851.65L2659.68,1828.84L2640.19,1828.84L2640.19,1872.17",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.896374,-1.09774e-16,1.09774e-16,-0.896374,5120.68,3505.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2640.19,1851.65L2659.68,1851.65L2659.68,1828.84L2640.19,1828.84L2640.19,1872.17",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896374,0,0,0.896374,281.103,181.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2688.74,1876.37L2662.97,1876.37L2662.97,1861.43L2672.99,1851.41L2688.71,1851.41L2688.71,1883.75",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896374,0,0,0.896374,281.103,181.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2701.47,1848.67L2701.47,1880.79",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896374,0,0,0.896374,281.103,181.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2701.47,1861.43L2717.37,1851.41L2726.35,1858L2726.35,1880.79",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.896374,0,0,0.896374,269.515,188.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2803.46,1871.15L2786.86,1871.15L2786.86,1841L2809.03,1841L2809.03,1855.21L2788.44,1855.21",
    style: {
      fill: "none",
      stroke: "rgb(57,57,57)",
      strokeWidth: "8.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.843818,0,0,0.979277,385.459,32.8277)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "2758.65px",
    y: "1906.7px",
    style: {
      fontFamily: "'Iosevka-Bold', 'Iosevka', monospace",
      fontWeight: 700,
      fontSize: "36.549px",
      fill: "rgb(57,57,57)"
    }
  }, "Board")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page-down-arrow4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf60d4b1d03f79d6ba964c283447b857.svg";
export { ForwardRef as ReactComponent };